import React from "react";
import { RouterProvider } from "react-router-dom";
import router from "./Routes";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./Theme";
import { Toaster } from "react-hot-toast";
import { ToastProvider } from "./Components/ToastProvider";
// import { HelmetProvider } from 'react-helmet-async'

export default function App() {
  return (
    <>
      {/* <HelmetProvider> */}
      <Toaster />
      <ThemeProvider theme={theme}>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
        <CssBaseline />
      </ThemeProvider>
      {/* </HelmetProvider>   */}
    </>
  );
}
